module.exports = __webpack_public_path__ + "static/media/dark-logo.b2e15af0.svg";